exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/layouts/admin/showephemeride/showephemeride.component.css
// module id = ../../../../../src/app/layouts/admin/showephemeride/showephemeride.component.css
// module chunks = main